import { useState, useEffect } from 'react'
import imgLogo from "../assets/logoMiniso123.jpg";
//import { Form } from 'react-bootstrap';
import FormFechas from '../Components/FormFechas';
import SelectCountry from '../Components/SelectCountry';
import DataConsultFechas from '../Components/DataConsultFechas';
import TableFechas from '../Components/TableFechas';
import axios from 'axios';
import { Spinner } from 'react-bootstrap';
import {BiHome} from 'react-icons/bi';
import {Link} from 'react-router-dom';
import { myURL } from '../assets/enviroment';
import TableFechasTodos from '../Components/TableFechasTodos';
import TableDataByStore from '../Components/TableDataByStore';
import { useNavigate } from 'react-router-dom';
import useUser from '../../../hooks/useUser';
import ProgressBar from 'react-bootstrap/ProgressBar';

//import { set } from 'mongoose';

const initDataFechas={
  fechaInicial:'',
  fechaFinal:''
}
const initDataVentas={
  dataAOM:{},
  dataHANA:[]
};
const countryArray=[
  {
    cod:'MX',
    name:'México'
  },
  {
    cod:'CO',
    name:'Colombia'
  },
  {
    cod:'PE',
    name:'Perú'
  },
  {
    cod:'CH',
    name:'Chile'
  }];
const GeneralMonitor = () => {
  const [dataFechas, setDataFechas] = useState(initDataFechas)
  const [dataVentas, setDataVentas] = useState(initDataVentas)
  const [dataVentasTodos, setDataVentasTodos] = useState([])
  const [myCountry, setMyCountry] = useState('')//['TD','MX','CO','PE','CH']
  const [loading, setLoading] = useState(false);
  const [isConsult, setIsConsult] = useState(false);
  const [isError, setIsError] = useState('');
  const [progressStatus, setProgressStatus] = useState(0);
  const [a,b,c,d,e,f,g,monitorUser,setMonitorUser,setDataMonitorLocalStorage,initialMonitorUser] = useUser();
  const navigate = useNavigate();
  const permisosMonitor=[...monitorUser.paises];
  const isMXUser=permisosMonitor.includes('MX');

  useEffect(() => {
    if (monitorUser?.user === "") {
      //console.log("monitorUser is FALSE:..", monitorUser);
      navigate("/loginMonitor");
    }
  }, [monitorUser]);

  const handleLogout = () => {
    setDataMonitorLocalStorage(initialMonitorUser);
    setMonitorUser(initialMonitorUser);
    //console.log("haciendo Logout:..", initialMonitorUser);
    navigate("/loginMonitor");
  };

  useEffect(() => {
    console.log('dataVentas(fuera):...',dataVentas);
    if(dataVentas.dataAOM.montoVentas&&dataVentas.dataHANA.length>0){
      console.log('dataVentas(dentro):...',dataVentas);
    }
  }, [dataVentas])


  const getdataByContry=async ()=>{
    try {
      setLoading(true);
    
    const {fechaInicial,fechaFinal}=dataFechas;
    let dataTodosPaises=[];
    const resultTDDevolution = await axios.get(`${myURL}getDataTDDevolution/${fechaInicial}/${fechaFinal}`);
      const dataTDDevolution = resultTDDevolution?.data;
    for (let index = 0; index < countryArray.length; index++) {
      const resultHANA = await axios.get(`${myURL}queryhana/${fechaInicial}/${fechaFinal}/${countryArray[index].cod}`);
      const resultAOM = await axios.get(`${myURL}queryaom/${fechaInicial}/${fechaFinal}/${countryArray[index].cod}`);
      const resultHANAByStore = await axios.get(`${myURL}queryhanaByStore/${fechaInicial}/${fechaFinal}/${countryArray[index].cod}`);
      const resultAOMByStore = await axios.get(`${myURL}queryaomByStore/${fechaInicial}/${fechaFinal}/${countryArray[index].cod}`);
      const dataHANAByStore = resultHANAByStore?.data;
      const dataAOMByStore = resultAOMByStore?.data;
      const dataAOM = resultAOM?.data;
      const dataHANA = resultHANA?.data;
      const resultAOMDevolution = await axios.get(`${myURL}queryaomEnterpriseDevolution/${fechaInicial}/${fechaFinal}/${countryArray[index].cod}`);
      const dataAOMDevolution = resultAOMDevolution?.data;
      //"/getDataTDDevolution/:fechaInicio/:fechaFinal"
      
      if(dataAOM&&dataHANA){
        const tempData={
          country:countryArray[index].name,
          dataAOM,
          dataHANA,
          dataAOMByStore,
          dataHANAByStore,
          dataAOMDevolution
        }
        console.log('tempData:...',tempData);
        dataTodosPaises.push(tempData);
        setProgressStatus((index+1)*25);
        if (index===countryArray.length-1) {
          //console.log('dataTodosPaises:...',dataTodosPaises);
          setDataVentasTodos([...dataTodosPaises,{country:'TD',dataTDDevolution}]);
          setLoading(false);
        }
        //console.log('dataTodosPaises:...',dataTodosPaises);
        
      }
    }
    } catch (error) {
      console.log(error)
    }

    
    
  }

  const consultVentas = async () => {
    const {fechaInicial,fechaFinal}=dataFechas;
    try {
      console.log(`Datos de consulta Pais(${myCountry}):...`,dataFechas);
      setDataVentas(initDataVentas);
      setDataVentasTodos([]);
      if(myCountry==='TD'){
        console.log('Consulta para todos los paises...');
        getdataByContry();
        return
      }
      setLoading(true);
      setIsConsult(false);
      setIsError('');
      
      const resultHANA = await axios.get(`${myURL}queryhana/${fechaInicial}/${fechaFinal}/${myCountry}`);
      const resultAOM = await axios.get(`${myURL}queryaom/${fechaInicial}/${fechaFinal}/${myCountry}`);
      const resultHANAByStore = await axios.get(`${myURL}queryhanaByStore/${fechaInicial}/${fechaFinal}/${myCountry}`);
      const resultAOMByStore = await axios.get(`${myURL}queryaomByStore/${fechaInicial}/${fechaFinal}/${myCountry}`);
      const dataHANAByStore = resultHANAByStore?.data;
      const dataAOMByStore = resultAOMByStore?.data;
      const dataAOM = resultAOM?.data;
      const dataHANA = resultHANA?.data;
      //"/queryaomEnterpriseDevolution/:fechaInicio/:fechaFinal/:pais"
      const resultAOMDevolution = await axios.get(`${myURL}queryaomEnterpriseDevolution/${fechaInicial}/${fechaFinal}/${myCountry}`);
      const dataAOMDevolution = resultAOMDevolution?.data;
      
      setLoading(false);
      if(dataAOM&&dataHANA){
        setDataVentas({
          ...dataVentas,
          dataAOM,
          dataHANA,
          dataAOMByStore,
          dataHANAByStore,
          dataAOMDevolution
        })
        setIsConsult(true);
        console.log('Consulta  exitosa...');
        console.log('resultAOM:...',resultAOM);
        console.log('resultHANA:...',resultHANA);
        let textError='';
        if(dataAOM.error){
          console.log('Consulta con Errores:..');
          textError=dataAOM.error;
        }
        if(dataHANA.error){
          console.log('Consulta con Errores:..');
          textError=`${textError} ${dataHANA.error}`;
        }
        setIsError(textError);

      }
      
    } catch (error) {
      console.log(error)
      setLoading(false);
    }
  }
  return (
    <div>
      <div className="d-flex justify-content-center align-items-center gap-2">
        <img
          style={{ width: "50px" }}
          className="mt-1"
          src={imgLogo}
          alt="imgLogo"
        />
        <h2 className="text-center text-secondary">Monitoreo Ventas</h2>
        <button onClick={handleLogout} type="button" className="btn btn-outline-info">Logout</button>
      </div>
      {isMXUser&&
        <div className='d-flex justify-content-end'>
        <Link to='/monitor'  className=''>
        <BiHome className='text-secondary me-3' size='2em'/>
        </Link>
      </div>
      }
      
      <div className='row'>
      <div className='col-12 col-md-6 '>
        <SelectCountry myCountry={myCountry} setMyCountry={setMyCountry} permisosMonitor={permisosMonitor}/>
          
          <FormFechas dataFechas={dataFechas} setDataFechas={setDataFechas}/>
      </div>

      <div className='col-12 col-md-6 d-flex justify-content-start align-items-center'>
          <DataConsultFechas fechaInicial={dataFechas.fechaInicial} fechaFinal={dataFechas.fechaFinal}/>
      </div>
      </div>

      <button 
      disabled={loading||dataFechas.fechaInicial===''||dataFechas.fechaFinal===''}
      onClick={consultVentas} 
      className='btn btn-primary d-block me-auto ms-auto w-25 my-3'>
        {loading?<Spinner animation="border" variant="light" />:'Consultar Ventas'}
        
      </button>
      {loading&&progressStatus>0&&<ProgressBar className='w-75 ms-auto me-auto' now={progressStatus} />}

      {isError&&<div className='fs-6 opacity-75 text-danger text-center me-auto ms-auto'>{isError}</div>}
      {isConsult&&!(dataVentasTodos.length>0)&&
      ( <div>
      <TableFechas dataVentas={dataVentas}/>
      
      
      <TableDataByStore dataVentas={dataVentas} pais={countryArray.find(item=>item.cod===myCountry)?.name||''}/>
      </div>
      )
      }

      {dataVentasTodos.length>0&&
      (
        <div>
      <TableFechasTodos dataVentas={dataVentasTodos}/>

      <TableDataByStore dataVentas={dataVentasTodos.find(item=>item.country==="México")} pais={"México"}/>
      <TableDataByStore dataVentas={dataVentasTodos.find(item=>item.country==="Colombia")} pais={"Colombia"}/>
      <TableDataByStore dataVentas={dataVentasTodos.find(item=>item.country==="Perú")} pais={"Perú"}/>
      <TableDataByStore dataVentas={dataVentasTodos.find(item=>item.country==="Chile")} pais={"Chile"}/>
      </div>
      )
      }
      

    </div>
  )
}

export default GeneralMonitor